import "./WaterHeaterReplacement.module.css";
import Header from "@/reusable_sections/Header";
import WaterHeaterHero from "./sections/WaterHeaterHero";
import ReplacementReasons from "./sections/ReplacementReasons";
import ServicesHub from "./sections/ServicesHub";
import Footer from "@/reusable_sections/Footer";
export default function WaterHeaterReplacementPage() {
  return <div>
      <Header />
      <WaterHeaterHero />
      <ReplacementReasons />
      <ServicesHub />
      <Footer />
    </div>;
}